










































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FinalDocument as IFinalDocument,
  FinalDocumentFisFrdoTypeEnum
} from "@/api/models/final-document";
import { User as IUser } from "@/api/models/user";
import TableActions from "@/components/form/TableActions.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";

@Component({ components: { CustomTableCol, CustomTableItem, TableActions } })
export default class FinalDocumentListItem extends Vue {
  @Prop() item!: IFinalDocument;
  @Prop() checkedData!: boolean;
  user!: IUser;
  isRemoving: boolean = false;
  checkedId!: string;

  data() {
    return {
      checkedId: undefined,
      user: undefined
    };
  }

  @Watch("checkedData")
  seeToData() {
    if (this.checkedData) {
      this.checkedId = this.item.id;
    } else {
      //@ts-ignore
      this.checkedId = undefined;
    }
  }

  @Watch("checkedId")
  pushToParent() {
    if (this.checkedId) {
      this.$emit("childData", this.checkedId);
    } else {
      this.$emit("clean", this.item.id);
    }
  }

  getFisFrdoType(type: FinalDocumentFisFrdoTypeEnum) {
    if (type === FinalDocumentFisFrdoTypeEnum.ProfessionalEducation) {
      return `${this.$tc(this.$translate.ProfessionalEducation)}`;
    }
    if (type === FinalDocumentFisFrdoTypeEnum.AdditionalProfessionalEducation) {
      return `${this.$tc(this.$translate.AdditionalProfessionalEducation)}`;
    }
    return type;
  }

  getUserById() {
    if (this.item && this.item.listenerId && this.item.protocol.listeners) {
      [this.user] = this.item.protocol.listeners
        .filter(el => el.id === this.item.listenerId)
        .map(el => el.user);
    }
  }

  editCurrentDocument() {
    this.$router.push({
      name: "finalDocumentEdit",
      params: { id: this.item.id }
    });
  }

  async removeDocument() {
    this.isRemoving = true;
    await this.$store.dispatch("finalDocuments/REMOVE", this.item.id);
    this.isRemoving = false;
  }

  mounted() {
    this.getUserById();
  }
}
